import React from 'react'
import { connect } from 'react-redux'
import FavoriteActivitiesHeader from './FavoriteActivitiesHeader'
import FavoriteActivitiesList from './FavoriteActivitiesList'
import FavoriteActivitiesPagination from './FavoriteActivitiesPagination'
import withDidMountRequest from 'app/connectors/withDidMountRequest'
import { favoriteActivities } from 'store/entities/favoriteActivities/actions'

const mapDispatchToProps = {
  onRequest: favoriteActivities.get.request,
}

const FavoriteActivities = ({ children }) => (
  <div className="favorite-activities">
    <FavoriteActivitiesHeader />
    <FavoriteActivitiesList />
    <FavoriteActivitiesPagination />
  </div>
)

FavoriteActivities.displayName = 'FavoriteActivities'

const FavoriteActivitiesWithDidMountRequest = withDidMountRequest(FavoriteActivities)

FavoriteActivitiesWithDidMountRequest.displayName = 'FavoriteActivitiesWithDidMountRequest'

const FavoriteActivitiesWithDidMountRequestContainer = connect(null, mapDispatchToProps)(
  FavoriteActivitiesWithDidMountRequest
)

FavoriteActivitiesWithDidMountRequestContainer.displayName = 'FavoriteActivitiesWithDidMountRequestContainer'

export default FavoriteActivitiesWithDidMountRequestContainer
